import api from "@/lib/api";
import { toast } from "sonner";

export async function startCheckout(lookup_key, user) {
  try {
    const { data } = await api.post("/payments/checkout", {
      lookup_key,
      origin_url: window.location.origin,
      user_id: user?.id || null,
    });
    if (data.checkout_url) window.location.href = data.checkout_url;
  } catch (e) {
    toast.error(e.response?.data?.detail || "Could not start checkout");
  }
}
